import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';
import {
  Style,
  fetchStyle,
  fetchStyles,
  filterStyleSizes,
  filterStyleSizesFromVariant,
  filterStyleVariants,
  findStyleGarmentMaster,
} from '../../garments';
// import { sendFitroomGarmentReq } from './ProductDetailFitroom';

const getRandomInt = (max: number) => {
  return Math.floor(Math.random() * max);
};

export const useProductDetail = () => {
  const { productId } = useParams();

  const [image, setImage] = useState<number>(0);
  const [style, setStyle] = useState<Style | null>(null);
  const [size, setSize] = useState<string | null>(null);
  const [variant, setVariant] = useState<string | null>(null);
  // const [isWidgetLoaded, setWidgetLoaded] = useState<boolean>(false);

  // Fetch style.
  useEffect(() => {
    (async () => {
      if (!productId) {
        return;
      }

      // Return to top.
      window.scrollTo(0, 0);

      // Fetch product.
      const style = await fetchStyle(productId);
      if (!style) {
        return;
      }
      setStyle(style);
      setVariant(style.variants[0].variant);

      // NOTE: Send to widget not required with forced mount.
      // if (isWidgetLoaded) {
      //   sendFitroomGarmentReq(style.variants[0].id, true);
      // }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ignore isWidgetLoaded
  }, [productId]);

  // Sizes and variants from style.
  const [sizes, variants] = useMemo(() => {
    if (!style) {
      return [[], []];
    }
    const sizes = filterStyleSizes(style);
    const variants = filterStyleVariants(style).map(g => ({
      id: g.id,
      image: g.preview,
      name: g.variant,
    }));
    return [sizes, variants];
  }, [style]);

  // Garment and sizes from style variant.
  const [garment, sizesFromVariant] = useMemo(() => {
    if (!style || !variant) {
      return [undefined, []];
    }
    const garment = findStyleGarmentMaster(style, variant);
    const sizesFromVariant = filterStyleSizesFromVariant(style, variant);
    return [garment, sizesFromVariant];
  }, [style, variant]);

  // Flag available sizes depending on variant.
  const sizesFlagged = useMemo(() => {
    return sizes.map(s => ({
      name: s,
      disabled: sizesFromVariant ? sizesFromVariant.every(sv => sv !== s) : true,
    }));
  }, [sizes, sizesFromVariant]);

  return {
    garment,
    image,
    productId,
    setImage,
    setSize,
    setVariant,
    // setWidgetLoaded,
    size,
    sizes: sizesFlagged,
    style,
    variant,
    variants,
  };
};

/**
 * Related products custom hook.
 */
export const useProductRelated = () => {
  const [styles, setStyles] = useState<Style[]>([]);

  // Fetch styles.
  useEffect(() => {
    (async () => {
      const styles = await fetchStyles();
      setStyles(styles);
    })();
  }, []);

  // Memoize random featuring.
  const featured = useMemo(() => {
    if (!styles.length) {
      return [];
    }
    const subset = Array.from({ length: 4 }, () => {
      return styles[getRandomInt(styles.length)];
    });
    return subset.map(s => ({
      id: s.id,
      image: s.preview,
      name: s.name,
      price: 100 * getRandomInt(10),
    }));
  }, [styles]);

  return { featured };
};
